import * as React from "react"
import { cn } from "../lib/utils.ts"

/*
 * shadcn/ui Input, restyled (components.md, Forms): a sunken well with the --border-control
 * edge (3:1), the --fg-subtle edge on hover, and on focus the accent edge plus a 3 px soft
 * accent ring (the control-field utility in theme.css). 12 px inset, 13 px text; 16 px text on
 * a phone so the page does not zoom.
 */
function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "control-field h-control w-full min-w-0 px-3 text-ui pointer-coarse:text-(length:--touch-input-font)",
        "file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-ui file:font-medium file:text-fg",
        className
      )}
      {...props}
    />
  )
}

export { Input }
